import axios from './productInstance'

const getViewProfiles = async (page: number = 1, size: number = 100): Promise<any[] | null> => {
  try {
    const response = await axios.get(`/view-profiles/`, {
      params: { page, size },
    })
    return response.data.contents || response.data || []
  } catch (error) {
    console.error('Error fetching view profile data:', error)
    return null
  }
}

export default getViewProfiles
